import { render, staticRenderFns } from "./RegisterDates.vue?vue&type=template&id=6867b4ea"
import script from "./RegisterDates.vue?vue&type=script&lang=js"
export * from "./RegisterDates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6867b4ea')) {
      api.createRecord('6867b4ea', component.options)
    } else {
      api.reload('6867b4ea', component.options)
    }
    module.hot.accept("./RegisterDates.vue?vue&type=template&id=6867b4ea", function () {
      api.rerender('6867b4ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/grid/RegisterDates.vue"
export default component.exports